module.exports = __webpack_public_path__ + "img/icon-add-button.9a97dcf5.svg";